
import React from 'react';
import '../../assets/css/demo.css'

const ScreenLoader = () => {
    return (
        <div className='screenload'>
            <div className='spinerPosition'>
                <i className="fa fa-spinner fa-spin" />
            </div>
        </div>)
}

export default ScreenLoader;
